module.exports = __webpack_public_path__ + "4bc7afa26fec6aa41056ff15e1bdb840.svg";